import axios from 'axios';
import type { TourItemDoc } from '@bb/domain/dist/schemas';
import type { JsonObject } from '@/app-package';

export type AddListingToTourResponse = JsonObject<
  TourItemDoc & {
    appointmentTourItemId: string;
    id: string;
    autoConfirm?: boolean;
    preBookingInformation?: string;
  }
>;

const addListingToTour = async (
  tourId: string,
  listingId: string,
): Promise<AddListingToTourResponse> => {
  const { data } = await axios.post<AddListingToTourResponse>(
    `/tours/${tourId}/add_listing_to_tour/${listingId}`,
  );

  return data;
};

export default addListingToTour;
